import { z } from "zod";

function zSchema<T extends z.ZodSchema>(item: T) {
  return z.object({
    items: z.array(item),
    totalCount: z.number().int().nonnegative(),
  });
}

type Schema<T extends z.ZodSchema> = z.infer<ReturnType<typeof zSchema<T>>>;

export { zSchema };
export type { Schema };
